import { Component, Input, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { Country } from '@vendasta/country-state';
import { GalaxyInputModule, SelectInputOptionInterface } from '@vendasta/galaxy/input';
import { map, take, tap } from 'rxjs/operators';
import { LocationService } from '../../../../../../data-services/location.service';
import { DynamicOptionsComponent } from '../dynamic-options';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-country-options',
  templateUrl: './country-options.component.html',
  styleUrls: ['./country-options.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyInputModule,
  ],
})
export class CountryOptionsComponent implements OnInit, DynamicOptionsComponent {
  countryOptionControl: UntypedFormControl = new UntypedFormControl('');
  countryOptions$ = this.countriesService.getCountries();
  countrySelectOptions$: Observable<SelectInputOptionInterface[]>;

  @Input() initialValue: string;
  selectedValue$ = this.countryOptionControl.valueChanges;

  constructor(private countriesService: LocationService) {}

  ngOnInit(): void {
    this.countryOptions$
      .pipe(
        take(1),
        tap((countries) => {
          this.countryOptionControl.setValue(this.initialValue || countries[0].code);
        }),
      )
      .subscribe();

    this.countrySelectOptions$ = this.countryOptions$.pipe(
      take(1),
      map((opts) => opts.map(this.mapCountryToOption)),
      map((options) =>
        options.map((option) => {
          if (option.value === this.initialValue) {
            option.selected = true;
          }
          return option;
        }),
      ),
    );
  }

  getSelectedValue(): string {
    return this.countryOptionControl?.value;
  }

  mapCountryToOption(country: Country): SelectInputOptionInterface {
    return {
      label: country.name,
      value: country.code,
    };
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.countryOptionControl];
  }

  isFormValid(): boolean {
    return true;
  }
}
